const routes = {
  landing : '/',
  game    : '/game',
  dev     : '/developers',
  solution: '/solution'
};

export default routes;